import { IDmKhoaActionTypes } from "../../action-types/category/IDmKhoaActions";
import { IDmKhoaReducer } from "../../reducer-model/category/IDmKhoaReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IDmKhoaReducer = {
  status: eReducerStatusBase.is_not_initialization,
  khoas: [],
};
export const khoaReducer = (
  state: IDmKhoaReducer = iniState,
  action: IDmKhoaActionTypes
): IDmKhoaReducer => {
  switch (action.type) {
    case "KHOA_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "KHOA_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        khoas: action.payload,
      };
    case "KHOA_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
